module.exports = __webpack_public_path__ + "img/blog_1.2bee5b81.png";